import CustomHTMLElement from '@onpace/onspace-core/components/html_element'

// The number of seconds after which the "still working" message replaces the default processing label.
const TAKING_LONGER_THRESHOLD = 30

export class OnspaceExplorerProcessing extends CustomHTMLElement {
  /// Sets up the processing indicator element.
  runFirstConnected() {
    super.runFirstConnected()

    this.labelElement = this.querySelector('[data-explorer-processing-label]')

    const startedAt = this.dataset.startedAt
    this.startedAt = startedAt ? new Date(startedAt) : new Date()
    if (Number.isNaN(this.startedAt.getTime())) {
      this.startedAt = new Date()
    }

    this.takingLongerLabel = this.dataset.labelTakingLonger || ''

    this.tick = this.tick.bind(this)
  }

  /// Callback when the element is connected to the DOM.
  runConnected() {
    super.runConnected()

    this.tick()
    this.intervalId = window.setInterval(this.tick, 1000)
  }

  /// Callback when the element is disconnected from the DOM.
  runDisconnected() {
    super.runDisconnected()

    if (this.intervalId) {
      window.clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  /// Swaps in the "taking longer" label after the threshold.
  tick() {
    const elapsedSeconds = Math.max(0, Math.floor((Date.now() - this.startedAt.getTime()) / 1000))

    if (this.labelElement) {
      const label = elapsedSeconds >= TAKING_LONGER_THRESHOLD ? this.takingLongerLabel : ''
      if (this.labelElement.textContent !== label) {
        this.labelElement.textContent = label
      }
    }
  }
}

window.customElements.define('onspace-chat-processing', OnspaceExplorerProcessing)
